import {getEntertainment} from "../../api/features/entertainment";

const state = () => ({

  entertainment:{},
  newsId: null
})

const getters = {
  get_entertainment(state) {
    return state.entertainment;
  },
}

const mutations = {
  SET_ENTERTAINMENT(state,data){
    state.entertainment = data;}
}

const actions = {
  async fetchEntertainment({ commit }) {
    try {
      const response = await getEntertainment();
      commit('SET_ENTERTAINMENT', response.data.results);
    } catch (error) {
    }
  },

}




export  default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
